import { render, staticRenderFns } from "./OrderBitacoraTab.vue?vue&type=template&id=07a83e50&"
import script from "./OrderBitacoraTab.vue?vue&type=script&lang=js&"
export * from "./OrderBitacoraTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports